import i18next from 'i18next'
import React, { useRef, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { BoxClass } from '../../../helper/classes'
import { Button } from '@blueprintjs/core'
import SelectPartOfTree from '../../commonInterface/selectPartOfTree'
import { walk } from 'react-sortable-tree'
import { getNodeKey } from '../../list/window1/functions'
import { globalOnDemandVars } from '../../../helper/context'
import { showToastByMenuDirection, truncateDefault } from '../../../helper/functions'
import ankiConnectInstallGuide from '../../../../assets/images/ankiconnectInstall.png'
import ankiConnectConfigGuide from '../../../../assets/images/ankiConnectConfig.gif'
import ankiExport from '../../../../assets/images/ankiExport.png'
import { useTranslation } from 'react-i18next'

async function invoke (action, params = {}) {
  const version = 6
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.addEventListener('error', () => reject(new Error('failed to issue request')))
    xhr.addEventListener('load', () => {
      try {
        const response = JSON.parse(xhr.responseText)
        if (Object.getOwnPropertyNames(response).length !== 2) {
          throw new Error('response has an unexpected number of fields')
        }
        if (!response.hasOwnProperty('error')) {
          throw new Error('response is missing required error field')
        }
        if (!response.hasOwnProperty('result')) {
          throw new Error('response is missing required result field')
        }
        if (response.error) {
          throw new Error(response.error)
        }
        resolve(response)
      } catch (e) {
        reject(e)
      }
    })

    xhr.open('POST', 'http://127.0.0.1:8765')
    xhr.send(JSON.stringify({ action, version, params }))
  })
}

/* nodeData: {
*     node: node,
    parentNode: parentNode,
    path: selfPath,
    lowerSiblingCounts: lowerSiblingCounts,
    treeIndex: currentIndex
    }
    * */
async function exportNodeDataArray (nodeDataArray) {
  await createModelForNodes()
  await Promise.all(nodeDataArray.map((nodeData) => (handleNodeData(nodeData))))
}

const modelForNodesName = 'LearnObit:nodes'
async function createModelForNodes () {
  const currentModels = await invoke('modelNames')
  const currentModelsResult = currentModels.result
  if (!currentModelsResult.some((modelName) => (modelName === modelForNodesName))) {
    await invoke('createModel', {
      modelName: modelForNodesName,
      inOrderFields: ['Context', 'Question', 'Answer'],
      css: '.card {\n' +
        ' font-size: 40px;\n' +
        ' text-align: center;\n' +
        '}\n',
      cardTemplates: [{
        Name: 'Default',
        Front: '{{Context}} >\n' +
          '<br>\n' +
          '{{Question}}',
        Back: '{{FrontSide}}\n' +
          '<hr>\n' +
          '{{Answer}}\n'
      }]
    })
  } else {
    return null
  }
}

async function handleNodeData (nodeData) {
  const deckName = truncateDefault(nodeData.node.title, true)
  await createDeck(deckName)
  const noteDataArray = await getNoteDataArrayFromNodeData(nodeData)
  await addNotes(noteDataArray, deckName)
}

async function createDeck (deckName) {
  await invoke('createDeck', { deck: deckName })
}

async function addNotes (noteDataArray, deckName) {
  const realNoteDataArray = noteDataArray.map((noteData) => {
    return {
      deckName: deckName,
      modelName: noteData.modelName,
      fields: noteData.fields,
      tags: ['LearnObit'],
      options: {
        allowDuplicate: true
      }
    }
  })

  await invoke('addNotes', {
    notes: realNoteDataArray
  })
}

async function getNoteDataArrayFromNodeData (nodeData) {
  const result = []

  const spreadsheetNodeArray = []
  walk({
    treeData: nodeData.node.id === 'rootNode' ? nodeData.node.children : [ nodeData.node ],
    ignoreCollapse: false,
    getNodeKey: getNodeKey,
    callback: async ({ node, parentNode, path, lowerSiblingCounts, treeIndex }) => {
      if (node.subtitle) {
        if (node.id === nodeData.node.id) {
          result.push(getNoteDataFromNode(nodeData.node, nodeData.parentNode))
        } else {
          result.push(getNoteDataFromNode(node, parentNode))
        }
      }

      if (node.isSpreadsheet) {
        spreadsheetNodeArray.push(node)
      }
    }
  })

  for (const spreadsheetNode of spreadsheetNodeArray) {
    await handleSpreadsheet(spreadsheetNode, result)
  }

  return result
}

function getNoteDataFromNode (node, parentNode) {
  return {
    modelName: modelForNodesName,
    fields: {
      Context: parentNode ? parentNode.title : globalOnDemandVars.topRootName(),
      Question: node.title,
      Answer: node.subtitle
    }
  }
}
// -----------------------------------------------------------------------------------------------------------
async function handleSpreadsheet (node, resultArray) {
  const modelName = 'LearnObit:' + truncateDefault(node.title, true)
  const spreadsheet = globalOnDemandVars.spreadsheets()[node.spreadsheetId]
  await createModelForSpreadsheet(modelName, spreadsheet)

  for (const row of spreadsheet.rows) {
    const rowFields = {}
    for (const rowKey of Object.keys(row)) {
      const rowMember = row[rowKey]
      if (typeof rowMember === 'string') {
        rowFields[rowKey] = rowMember
      }
    }
    resultArray.push({
      modelName: modelName,
      fields: rowFields
    })
  }
}

async function createModelForSpreadsheet (modelName, spreadsheet) {
  const currentModels = await invoke('modelNames')
  const currentModelsResult = currentModels.result
  if (!currentModelsResult.some((oneOfModelNames) => (oneOfModelNames === modelName))) {
    await invoke('createModel', {
      modelName: modelName,
      inOrderFields: spreadsheet.columns,
      cardTemplates: [{
        Name: 'Default',
        Front: getCardContent('front', spreadsheet.selectedItems1),
        Back: getCardContent('back', spreadsheet.selectedItems2)
      }],
      css: getCSS(spreadsheet.configForItems1, spreadsheet.configForItems2)
    })
  }
}

function getCardContent (direction, selectedItems) {
  let result = selectedItems.map((item) => (
    `<div id="${item}-${direction}">{{${item}}}</div>`
  )).join('')

  if (direction === 'back') {
    result = '<div id="FrontSide">{{FrontSide}}</div>' + result
  }
  return result
}

function getCSS (frontConfig, backConfig) {
  const commonCSS = '.card {\n' +
    ' font-size: 20px;\n' +
    ' text-align: center;\n' +
    '}\n' +
    '\n' +
    '#FrontSide {\n' +
    ' float: left;\n' +
    ' border-right: solid 1px;\n' +
    ' padding: 0 20px;\n' +
    ' position: absolute;\n' +
    '}\n'

  let frontCSS = ''
  for (const key of Object.keys(frontConfig)) {
    frontCSS += `
 #${key}-front {
   font-size: ${frontConfig[key].fontSize}px;
 }
 
    `
  }

  let backCSS = ''
  for (const key of Object.keys(backConfig)) {
    backCSS += `
 #${key}-back {
   font-size: ${backConfig[key].fontSize}px;
 }
 
    `
  }

  return (commonCSS + '\n' + frontCSS + '\n' + backCSS)
}

// -----------------------------------------------------------------------------------------------------------

function AnkiAddOn () {
  const selectPartOfTreeRef = useRef(null)
  const { t } = useTranslation()

  return (
    <div css={css`text-align: center;`}>
      <br />
      <Button text={t('How to export LO\'s data to Anki')} css={css`margin: auto;`} onClick={() => {
        globalOnDemandVars.openGlobalDialog()(i18next.t('How to export'), <div css={css`text-align: center;`}>
          <br /><br />
          {t('explanationForAnki.1')}
          <br /><br />
          <img src={ankiConnectInstallGuide} css={css`margin: auto;`} />
          <br /><br />
          {t('explanationForAnki.2')}
          <br /><br />
          <img src={ankiConnectConfigGuide} css={css`margin: auto;`} />
          <br /><br />
          {t('explanationForAnki.3')}
          <br /><br />
          <img src={ankiExport} css={css`margin: auto;`} />
          <br /><br /><br /><br />

          {t('explanationForAnki.4')}
          <br />
          {t('explanationForAnki.5')}
          <br /><br />
        </div>, 'bigger')
      }} />
      <br /><br />
      <SelectPartOfTree ref={selectPartOfTreeRef} popoverHeight={60} lazyData />
      <Button css={css`margin: auto;`}
        text={t('Export to Anki')} icon='export' onClick={async () => {
          const response = await invoke('version')

          if (!response.error) {
            const nodeDataArray = selectPartOfTreeRef.current.getSelectedNodeData()
            await exportNodeDataArray(nodeDataArray)
            selectPartOfTreeRef.current.clearSelectedNodeData()
          } else if (response.error === 'collection is not available') {
            showToastByMenuDirection({
              message: t('It couldn\'t find Anki running')
            })
          } else {
            showToastByMenuDirection({
              message: t('Some error occurred')
            })
          }
        }}
      />
    </div>
  )
}

const AnkiAddOnBoxClass = new BoxClass(AnkiAddOn, 'Anki', null, 3, { order: 6 })

export default AnkiAddOnBoxClass
